import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Image from "../../components/image";
import Blog from "../../components/blogFooter/blogFooter";
import { asset } from "../../helpers/dom.helper";
import { ContentWrapper } from "../../layouts";
import { Media, MediaContextProvider } from "../../media";
import BgWithText from '../../components/backgroundWithText/BgWithText';
import styles from './lpr.module.scss';
import Guarantee from "../../pages/Home/guaranteeHome";
import RegisterHome from "../../pages/Home/registerHome";
import i18n, { toRoute } from "../../i18n";

export default function LPR() {

  const { t } = useTranslation(['translation', 'aiFacial'])

  return (
    <>
      <Helmet>
        <title>{t("aiFacial:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) คืออะไร มีประโยชน์อย่างไร l Silverman")}</title>
        <meta name="description" content={t("aiFacial:กล้องอ่านป้ายทะเบียนรถหรือกล้อง LPR คืออะไร มีระบบการทำงานอย่างไร ควรติดตั้งอย่างไร และมีประโยชน์ต่อการรักษาความปลอดภัยอย่างไรบ้าง")} />
        <meta name="keywords" content={t("aiFacial:metaKeyWord")} />
        <link rel="canonical" href="https://silverman.app/debtcollection" />              
      </Helmet>

      <div className={styles.aiFacial}>
            {/* <div className={`card ${styles.banner}`}>
            <Image desktop={asset('/images/aiFacial/ai-banner.webp')} mobile={asset('/images/aiFacial/ai-banner.webp')} className="card-img" alt={t(t("guard:title"))} />
            <div className="card-img-overlay">
                <div className="d-flex align-items-center h-100">
                <div className="card-title w-100">
                    <h2 className="text-menu-title mt-5 mb-0" dangerouslySetInnerHTML={{ __html: t('aiFacial:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) คืออะไร? มีประโยชน์อย่างไรบ้าง') }} />
                </div>
                </div>
            </div>
            </div> */}
             <MediaContextProvider>
              <Media lessThan="md">
                <BgWithText
                  data={{
                     subtitle: t('settingUpJuristic:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) คืออะไร? มีประโยชน์อย่างไรบ้าง')
                  }}
                  image={asset('/images/settingUpJuristic/main.jpg')}
                  height={350}
                  noBGPosition={true}
                />
              </Media>
              <Media greaterThanOrEqual="md">
                <BgWithText
                  data={{
                    subtitle: t('settingUpJuristic:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) คืออะไร? มีประโยชน์อย่างไรบ้าง')
                  }}
                  image={asset('/images/settingUpJuristic/main.jpg')}
                  height={350}
                  noBGPosition={true}
                />
              </Media>
            </MediaContextProvider>
        {/* end banner */}

        {/* section1 */}
        <ContentWrapper className="py-5 main-ai-facial">
        <div style={{maxWidth:'1100px',margin:'auto'}}>
        <h5 className="mb-4 font-weight-400 text-center" 
                dangerouslySetInnerHTML={{ __html: t('aiFacial:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) คืออะไร? มีประโยชน์อย่างไรบ้าง') }} />
            <p className="mb-4 font-weight-400 text-center" 
                dangerouslySetInnerHTML={{ __html: t('aiFacial:ปัจจุบันเทคโนโลยีทุกด้านพัฒนาไปข้างหน้าแบบก้าวกระโดด รวมถึงเรื่องของความปลอดภัยด้วยเช่นกัน ปกติทุกคนมักคุ้นเคยกับเรื่องของกล้องวงจรปิดติดตั้งเพื่อบันทึกภาพเหตุการณ์ต่าง ๆ แต่ทุกวันนี้อีกนวัตกรรมสุดทันสมัยต้องยกให้กับกล้องอ่านป้ายทะเบียนรถ หรือ กล้อง LPR ซึ่งใครที่สงสัยว่าระบบ LPR หรือกล้อง License Plate Recognition คืออะไร มีประโยชน์ต่อการนำมาใช้งานมากน้อยแค่ไหน ลองมาศึกษาข้อมูลเหล่านี้กันได้เลย') }} />
        <div className="row">
            <div className="col-12 col-sm-6 pr-sm-0">
                <div className="mt-4">
                    <Image src={asset('/images/lpr/lpr-1.webp')} />
                </div>
            </div>
            <div className="col-12 col-sm-6 pl-sm-0">
              <div>
                  <p> <strong>{t('aiFacial:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) คืออะไร?')} </strong> </p>
                  <p dangerouslySetInnerHTML={{ __html: t('aiFacial:กล้องอ่านป้ายทะเบียนรถ หรือ กล้อง LPR คือ กล้องวงจรปิดประเภทหนึ่งที่ถูกพัฒนาขึ้นมาเพื่อใช้ในการอ่านป้ายทะเบียนรถยนต์เป็นหลัก ทำงานร่วมกับระบบซอฟต์แวร์คอมพิวเตอร์เพื่อประเมินผลและระบบไม้กั้นทางเข้า-ออกอัตโนมัติเพื่ออ่านป้ายทะเบียนและเปิด-ปิดประตูเข้าออกหมู่บ้าน รวมถึงอาคารต่าง ๆ ช่วย ช่วยเพิ่มความสะดวกรวดเร็ว และความปลอดภัยได้เป็นอย่างดี สามารถอ่านพร้อมบันทึกข้อมูลได้ทั้งรถยนต์และรถจักรยานยนต์ ทั้งป้ายขาวอักษรดำปกติ ป้ายประมูล รถป้ายแดง ป้ายเหลือง ป้ายเขียว หากมีการออกโดยกรมขนส่งทางบก ตัวกล้องอ่านป้ายทะเบียนนี้สามารถดำเนินการภายใต้ความแม่นยำระดับ 95 - 98% เลยทีเดียว') }} />
              </div>
            </div>
        </div><br></br><br></br>

        <div>
            <p> <strong>{t('aiFacial:ระบบกล้องอ่านป้ายทะเบียนรถยนต์ (LPR) ทำงานอย่างไร?')} </strong> </p>
            <div style={{float:'right',padding:'3px'}}>
                <img src={asset('/images/lpr/lpr-2.webp')} />
            </div>
            <p dangerouslySetInnerHTML={{ __html: t('aiFacial:ระบบกล้องอ่านป้ายทะเบียนรถยนต์ หรือ LPR ย่อมาจาก License Plate Recognition ซึ่งให้ความหมายคือกล้องอ่านป้ายทะเบียนรถ เป็นอีกเทคโนโลยีที่น่าสนใจมาก การทำงานของระบบ LPR หรือ ระบบตรวจจับป้ายทะเบียน คือ เมื่อมีรถยนต์หรือรถจักรยานยนต์วิ่งเข้ามาบริเวณด้านหน้าไม้กั้นทางเข้า-ออก ตัวกล้องจะดำเนินการถ่ายภาพรถพร้อมระบุตำแหน่งทะเบียนรถแบบอัตโนมัติ ตามด้วยการส่งต่อไปยังโปรแกรมที่ถูกติดตั้งเอาไว้เพื่อวิเคราะห์ ประเมิน และถอดข้อมูลด้วยระบบ Optical Character ') }} />
            <p dangerouslySetInnerHTML={{ __html: t('aiFacial:Recognition (OCR) ซึ่งเป็นระบบการจดจำอักขระด้วยแสงให้ออกมาในลักษณะของตัวเลข หมวด ตัวอักษร จังหวัด ไปจนถึงยี่ห้อรถ สีรถ จึงช่วยอำนวยความสะดวกในการนำข้อมูลการเข้า-ออกของรถไปใช้งานต่อในเรื่องอื่น ๆ ได้เป็นอย่างดี')}} />
            <p dangerouslySetInnerHTML={{ __html: t('aiFacial:ในกรณีที่ตัวกล้องทำงานร่วมกับไม้กั้นทางเข้า-ออก เมื่อระบบของกล้องทำการวิเคราะห์ ประเมิน ถอดข้อมูลออกมาเสร็จครบถ้วนแล้ว ไม้กั้นจะถูกยกขึ้นทันทีภายในเวลาไม่เกิน 3-5 วินาที อย่างไรก็ตาม ระบบดังกล่าวมักต้องใช้กับรถที่ลงทะเบียนกับโครงการ หรือผู้ให้บริการรักษาความปลอดภัยแห่งนั้นก่อน เช่น เป็นผู้อยู่อาศัยของหมู่บ้าน เป็นพนักงานที่มีออฟฟิศอยู่บนอาคารสำนักงาน เป็นต้น ส่วนผู้มาเยี่ยมเยียนก็จะดำเนินการในระบบเดียวกัน')}} />
            <p dangerouslySetInnerHTML={{ __html: t('aiFacial:ทั้งนี้ ขอเพิ่มเติมข้อมูลเกี่ยวกับการใช้งานระบบการตรวจจับป้ายทะเบียน LPR อีกเล็กน้อย กรณีที่ตัวกล้องเจอเข้ากับรถป้ายทะเบียนซีดจาง ลอก ชำรุด ไม่สามารถมองเห็นตัวเลขหรือตัวอักษร มีการติดแผ่นทอง ติดสติ๊กเกอร์ทับ รวมถึงมีการใช้ทะเบียนปลอมที่ไม่ได้ผ่านการออกอย่างถูกต้องตามกฎหมายโดยกรมการขนส่งทางบก ตัวกล้องจะไม่สามารถอ่านค่าของป้ายทะเบียนนั้นได้')}} />
        </div>

        <div>
            <p> <strong>{t('aiFacial:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) มีประโยชน์อย่างไรบ้าง?')} </strong> </p>
            <div >
                <img src={asset('/images/lpr/lpr-3.webp')} />
            </div>
            <p className="pt-4" dangerouslySetInnerHTML={{ __html: t('aiFacial:หลังจากรู้จักกับระบบการทำงานของกล้องจับป้ายทะเบียนกันไปแล้ว คราวนี้ขอสรุปถึงประโยชน์ดี ๆ ที่ทุกฝ่ายจะได้รับเมื่อเลือกใช้งานกล้อง LPR เพื่อการตัดสินใจที่ง่ายขึ้นกว่าเดิม ทั้งเรื่องการติดตั้งเพื่อใช้กับโครงการของตนเอง หรือการเลือกบริษัทผู้ดูแลโครงการที่มีระบบ LPR เป็นส่วนหนึ่งของการทำงาน มาดูกันเลย') }} />
            <ul style={{listStyle:'none'}}>
                <li>
                    <p style={{margin:0}}><strong>{t('aiFacial:1. สะดวกสบายต่อทุกฝ่าย')} </strong></p>
                    <span>{t('aiFacial:กล้องอ่านป้ายทะเบียนรถจะสร้างความสะดวกสบายให้กับผู้ใช้รถยนต์และเจ้าหน้าที่ดูแลความปลอดภัย ด้วยการเป็นระบบอัตโนมัติ ใช้เวลาวิเคราะห์ ประเมิน และอนุมัติข้อมูลไม่เกิน 5 วินาที ผู้ขับขี่ก็ขับรถต่อได้เลย ดังนั้นเจ้าหน้าที่จึงไม่จำเป็นต้องแลกบัตรหรือยกไม้กั้นทางเข้าให้ยุ่งยาก')}</span>
                </li>
                <li>
                    <p style={{margin:0}} className="pt-2"><strong>{t('aiFacial:2. เพิ่มความปลอดภัยให้กับสถานที่นั้น ๆ ได้เป็นอย่างดี')} </strong></p>
                    <span>{t('aiFacial:กล้องอ่านป้ายทะเบียนรถจะช่วยยกระดับความปลอดภัยให้กับพื้นที่นั้น ๆ โดยเฉพาะบริเวณที่มีความเป็นส่วนตัวสูง เช่น หมู่บ้าน คอนโด เพราะรถที่จะผ่านได้ต้องมีการลงทะเบียนเฉพาะรถคันดังกล่าวเท่านั้น อีกทั้งหากตัวกล้องเจอเข้ากับทะเบียนปลอมหรือการสวมทะเบียน ก็จะมีการแจ้งเตือนและไม่อนุญาตให้รถคันดังกล่าวผ่านด้วย')}</span>
                </li>
                <li>
                    <p style={{margin:0}} className="pt-2"><strong>{t('aiFacial:3. นำข้อมูลการบันทึกที่ได้ไปใช้งานในด้านอื่น ๆ ต่อ')} </strong></p>
                    <span>{t('aiFacial:ข้อมูลที่ได้รับจากกล้องอ่านป้ายทะเบียนรถหรือ LPR สามารถนำไปใช้งานด้านอื่น ๆ ได้อีก เช่น ใช้เป็นหลักฐานของทางเจ้าหน้าที่ตำรวจ ใช้เป็นสถิติบ่งบอกช่วงเวลาที่รถเข้า-ออกเยอะเพื่อเพิ่มพนักงานประจำกะให้มากขึ้นกว่าเดิม เป็นต้น ซึ่งผู้ใช้สามารถดาวน์โหลดออกมาเป็นไฟล์ Excel หรือไฟล์ PDF ได้อีกด้วย')}</span>
                </li>
                <li>
                    <p style={{margin:0}} className="pt-2"><strong>{t('aiFacial:4. สามารถใช้งานได้ทุกช่วงเวลา มีความแม่นยำสูง')} </strong></p>
                    <span>{t('aiFacial:กล้อง LPR สามารถใช้งานได้ตลอดเวลาทั้งช่วงกลางวันและกลางคืน ด้วยตัวเลนส์กล้องแบบ WDR เพิ่มความคมชัดได้อย่างมีประสิทธิภาพ รวมถึงฟังก์ชันส่องผ่านไฟห้าและไฟท้ายรถ เพื่อให้การบันทึกชัดเจนทุกสถานการณ์ไม่ว่าช่วงเวลาใดก็หายห่วง แถมความคมชัดและระดับความแม่นยำยังสูงมากเฉลี่ย 95-98% เลยทีเดียว')}</span>
                </li>
                <li>
                    <p style={{margin:0}} className="pt-2"><strong>{t('aiFacial:5. ใช้งานร่วมกับอุปกรณ์อื่น ๆ ได้')} </strong></p>
                    <span>{t('aiFacial:นอกจากการเป็นกล้องเพื่อคอยตรวจจับป้ายทะเบียนแล้ว กล้องอ่านป้ายทะเบียนรถยังสามารถใช้งานร่วมกับอุปกรณ์อื่น ๆ ได้อีกด้วย จึงช่วยเพิ่มความทันสมัย สะดวก ทำงานได้เร็วขึ้นกว่าเดิม เช่น ไม้กั้นทางเข้า-ออก (แบบที่ได้อธิบายไว้ข้างต้น) ระบบการคิดค่าจอดรถ ระบบบันทึกเวลาจอด เป็นต้น')}</span>
                </li>
            </ul>
        </div>
         
          <div className="pt-4">
              <p> <strong>{t('aiFacial:กล้องอ่านป้ายทะเบียนรถยนต์ (LPR) ควรติดตั้งอย่างไร เหมาะกับสถานที่แบบใดบ้าง?')} </strong> </p>
              <p dangerouslySetInnerHTML={{ __html: t('aiFacial:สำหรับผู้ที่สนใจติดตั้งกล้องวงจรปิดอ่านป้ายทะเบียน ทุกวันนี้เหล่าบรรดากล้อง LPR ราคาไม่ได้แพงแต่อย่างใด สามารถเลือกยี่ห้อที่มีคุณภาพ เช่น กล่องอ่านป้ายทะเบียนรถ Hikvision เพื่อประสิทธิภาพที่ดีของการทำงานได้ อย่างไรก็ตามหลักการสำคัญของการติดตั้ง มีดังต่อไปนี้') }} />
              <div>
                <Image src={asset('/images/lpr/lpr-4.webp')} />
              </div>
              <ul className="pt-4">
                <li>
                    <p><strong> ติดกล้องให้อยู่ในระดับที่สามารถมองเห็นป้ายทะเบียนและรถทั้งคันได้ชัดเจน </strong>เผื่อกรณีต้องใช้ใบหน้าผู้ขับขี่เป็นหลักฐานหรือลักษณะเพิ่มเติมอื่นของรถ เช่น ยี่ห้อ รุ่น สี ระดับกล้องดังกล่าวจะช่วยบันทึกข้อมูลทั้งหมดของรถทุกคนได้อย่างยอดเยี่ยม</p>
                </li>
                <li>
                    <p><strong> มีการเชื่อมต่อระบบเข้ากับป้อมยามเพื่อให้เจ้าหน้าที่ดูแลเพิ่มเติม </strong>กรณีเกิดเรื่องไม่คาดฝัน เช่น กล้องอ่านป้ายทะเบียนไม่ได้เนื่องจากป้ายสีซีด เจ้าหน้าที่ รปภ. ก็สามารถกดเปิด-ปิดไม้กั้นทางเข้า-ออกเพื่ออำนวยความสะดวกแทน หรือตรวจสอบความผิดปกติของรถคันดังกล่าวได้</p>
                </li>
                <li>
                    <p> <strong>ควรติดตั้งอยู่ด้านหน้าไม้กั้นฝั่งที่รถจะวิ่งผ่านเสมอ</strong>และห้ามให้มีสิ่งใดบดบังระยะของกล้องเป็นอันขาด เพื่อการจับภาพจะได้ถูกต้อง แม่นยำ ไม่เกิดปัญหาหรือบันทึกข้อมูลผิดพลาดภายหลัง                    </p>
                </li>
              </ul>

              <p>ทั้งนี้หลายคนอาจยังมีข้อสงสัยเพิ่มเติมว่ากล้องอ่านป้ายทะเบียนรถนี้ควรติดตั้งกับสถานที่แบบใดบ้าง? ขอแนะนำแบบง่าย ๆ เลยว่าสามารถติดตั้งได้กับทุกสถานที่หากมีการจอดรถไม่ว่าจะเป็นคอนโด หมู่บ้านจัดสรร โรงแรม ห้าง โรงพยาบาล สถานที่ราชการ อาคารสำนักงาน ลานจอดรถเอกชน โรงงาน และสถานที่อื่น ๆ หากมีพื้นที่สำหรับจอดรถ หรือเป็นจุดจอดรถที่มีคนคอยดูแลชัดเจน
              </p>
              <div>
                <Image src={asset('/images/lpr/lpr-5.webp')} />
              </div>
              <p className="pt-4">ระบบ LPR หรือระบบกล้องอ่านป้ายทะเบียนรถ เป็นเทคโนโลยีที่สามารถจับภาพป้ายทะเบียนของรถทุกคันที่ผ่านเข้ามาในบริเวณที่กำหนดและเก็บข้อมูลไว้สำหรับการตรวจสอบได้ ซึ่งในปัจจุบันกล้องอ่านป้ายทะเบียนรถมีราคาที่เข้าถึงได้ง่าย และสามารถติดตั้งได้ไม่ยาก</p>
              <p>หากคุณสนใจระบบบริหารจัดการเกี่ยวกับผู้มาติดต่อ พร้อมควบคุมการเข้าออกของยานพาหนะอัตโนมัติผ่านระบบ AI อ่านป้ายทะเบียนรถยนต์ และใช้เทคโนโลยี LPR ที่มีประสิทธิภาพ Silverman ยินดีให้บริการโดยทีมงานมืออาชีพ พร้อมการติดตั้งกล้องและการดูแลครบวงจร ไม่ว่าจะเป็นนิติบุคคล โครงการที่อยู่อาศัย เจ้าของพื้นที่จอดรถ ผู้บริหารห้าง ผู้บริหารโรงพยาบาล ฯลฯ เราพร้อมให้บริการในทุกพื้นที่ ติดต่อผู้เชี่ยวชาญของเราได้เลย</p>
          </div>
        </div>
        <h5 className="mb-2 font-weight-400 text-center pt-5" 
            dangerouslySetInnerHTML={{ __html: t('aiFacial:contact-detail') }} />
        <div className="text-center">
        <button type="submit" className="btn btn-primary py-2 btn-register">
          <Link to={toRoute("/register")}>
                {t("aiFacial:Free Consult")}
          </Link>
        </button>
        </div>
        </ContentWrapper>

        <br></br><br></br>
        <Guarantee />
        <br></br><br></br>

        <Blog />
      </div>
    </>

  )

}
